/* nb-acc-buy.js — accessory PDP buy section: machine-choice step, pack
   filtering, gallery tile swap + "What's inside" scroll, and the phone
   sticky bar's show/hide. Scoped to each [data-nb-acc-buy] root and each
   [data-nb-acc-gallery] root so two instances on one page never contend.
   No price/copy strings live here; everything is read from data attributes
   the Liquid sections already wrote from real product objects. */
(function () {
  function markInit(el, name) {
    var key = 'nbInit' + name;
    if (el.dataset[key]) return false;
    el.dataset[key] = 'true';
    return true;
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* ---------------- choice step + pack filter ---------------- */
  function initChoiceRoot(root) {
    if (!markInit(root, 'accBuy')) return;

    var choiceInputs = root.querySelectorAll('[data-nb-acc-choice-input]');
    if (!choiceInputs.length) return;

    var fitsEl = root.querySelector('[data-nb-acc-fits]');
    var cta = root.querySelector('[data-nb-acc-cta]');
    var stickyCta = root.querySelector('[data-nb-acc-sticky] [data-nb-cart-add]');
    var packWraps = root.querySelectorAll('[data-nb-acc-pack-filter]');

    function applyChoice(input) {
      var variantId = input.getAttribute('data-nb-acc-choice-product');
      var fits = input.getAttribute('data-nb-acc-choice-fits');
      var index = input.value;

      if (fits && fitsEl) fitsEl.textContent = fits;

      [cta, stickyCta].forEach(function (btn) {
        if (!btn) return;
        if (variantId) {
          btn.setAttribute('data-nb-variant-id', variantId);
          btn.disabled = false;
          btn.removeAttribute('aria-disabled');
        } else {
          btn.disabled = true;
          btn.setAttribute('aria-disabled', 'true');
        }
      });

      packWraps.forEach(function (wrap) {
        var filter = wrap.getAttribute('data-nb-acc-pack-filter');
        wrap.hidden = !!(filter && filter !== index);
      });
    }

    choiceInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        applyChoice(input);
      });
      if (input.checked) applyChoice(input);
    });
  }

  /* ---------------- gallery: tile swap + What's inside scroll ---------------- */
  function initGalleryRoot(root) {
    if (!markInit(root, 'accGallery')) return;

    var tiles = root.querySelectorAll('[data-nb-acc-gallery-tile]');
    var heroImgs = root.querySelectorAll('[data-nb-acc-gallery-hero-img]');

    function selectTile(index) {
      tiles.forEach(function (tile) {
        var isActive = tile.getAttribute('data-nb-acc-gallery-tile') === String(index);
        tile.classList.toggle('is-active', isActive);
        tile.classList.toggle('border-cobalt', isActive);
        tile.classList.toggle('border-hair', !isActive);
        if (isActive) {
          tile.setAttribute('aria-current', 'true');
        } else {
          tile.removeAttribute('aria-current');
        }
      });
      heroImgs.forEach(function (img) {
        img.hidden = img.getAttribute('data-nb-acc-gallery-hero-img') !== String(index);
        img.classList.toggle('hidden', img.getAttribute('data-nb-acc-gallery-hero-img') !== String(index));
      });
    }

    tiles.forEach(function (tile) {
      tile.addEventListener('click', function () {
        selectTile(tile.getAttribute('data-nb-acc-gallery-tile'));
      });
    });

    var insideTile = root.querySelector('[data-nb-acc-gallery-inside]');
    if (insideTile) {
      insideTile.addEventListener('click', function () {
        var targetId = insideTile.getAttribute('data-nb-acc-scroll-target');
        if (!targetId) return;
        var target = document.getElementById(targetId);
        if (!target) return;
        if (typeof target.open !== 'undefined') target.open = true;
        target.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
      });
    }
  }

  /* ---------------- phone sticky bar ---------------- */
  function initStickyRoot(bar) {
    if (!markInit(bar, 'accSticky')) return;
    var watchId = bar.getAttribute('data-nb-acc-watch');
    var watchEl = watchId && document.getElementById(watchId);
    if (!watchEl || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          // Visible once the main CTA has scrolled OUT of view; hidden while it is in view.
          bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      },
      { threshold: 0 }
    );
    observer.observe(watchEl);
  }

  function initAll() {
    document.querySelectorAll('[data-nb-acc-buy]').forEach(initChoiceRoot);
    document.querySelectorAll('[data-nb-acc-gallery]').forEach(initGalleryRoot);
    document.querySelectorAll('[data-nb-acc-sticky]').forEach(initStickyRoot);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
